// Service worker registration
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js")
}

import "@hotwired/turbo-rails"
import "./controllers"

// Replace browser confirm() with tavern-styled <dialog>
Turbo.config.confirmMethod = (message) => {
  return new Promise((resolve) => {
    const dialog = document.getElementById("tavern-confirm-dialog")
    const msg    = document.getElementById("tavern-confirm-message")
    const ok     = document.getElementById("tavern-confirm-ok")
    const cancel = document.getElementById("tavern-confirm-cancel")
    if (!dialog) { resolve(window.confirm(message)); return }

    msg.textContent = message
    dialog.showModal()

    const cleanup = (result) => {
      dialog.close()
      ok.removeEventListener("click", onOk)
      cancel.removeEventListener("click", onCancel)
      resolve(result)
    }
    const onOk     = () => cleanup(true)
    const onCancel = () => cleanup(false)
    ok.addEventListener("click", onOk, { once: true })
    cancel.addEventListener("click", onCancel, { once: true })
    dialog.addEventListener("cancel", () => cleanup(false), { once: true })
  })
}
import "./trix/trix_exts"
import "trix"
import "@rails/actiontext"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()

// Put this somewhere in /app/javascript
document.addEventListener("turbo:before-fetch-request", (event) => {
  event.detail.fetchOptions.headers["X-Turbo-Nonce"] =
    document.querySelector("meta[name='csp-nonce']")?.content
})

document.addEventListener("turbo:before-cache", () => {
  document.querySelectorAll("script[nonce]").forEach((element) => {
    element.setAttribute("nonce", element.nonce);
  })
})
